import { render, staticRenderFns } from "./WasteDealList.vue?vue&type=template&id=466dd312&scoped=true&"
import script from "./WasteDealList.vue?vue&type=script&lang=js&"
export * from "./WasteDealList.vue?vue&type=script&lang=js&"
import style0 from "./WasteDealList.vue?vue&type=style&index=0&id=466dd312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466dd312",
  null
  
)

export default component.exports